import { Component, Input, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { GroupClassEventDetailsModel } from '@bayclubs/court-booking-employee-api';

import { GroupClassAutologinProviderService } from "@core/core.module";
import { CourtEventNoteSaveLauncherService, SaveCourtEventNoteSuccessAction } from '@court-event-note-save/court-event-note-save.module';

import { CourtEventDetailsFacade } from '../../+store/court-event-details.facade';

@Component({
    selector: 'app-court-class-item-details',
    templateUrl: './court-class-item-details.component.html',
    styleUrls: ['./court-class-item-details.component.scss'],
    standalone: false
})
export class CourtClassItemDetailsComponent implements OnInit {
    @Input() courtEventId: string;

    courtClass$ = this.courtEventDetailsFacade.courtClassDetails$;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private courtEventDetailsFacade: CourtEventDetailsFacade,
        private urlService: GroupClassAutologinProviderService,
        private courtEventNoteSaveLauncherService: CourtEventNoteSaveLauncherService,
        private actions$: Actions) { }

    ngOnInit(): void {
        this.courtEventDetailsFacade.loadCourtClassDetails(this.courtEventId);

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.courtEventDetailsFacade.loadCourtClassDetails(this.courtEventId);
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventDetailsFacade.clearLoadedBlockedSlotDetails();

        this.subscriptions.unsubscribe();
    }

    groupClassesUrl() {
        const url = this.urlService.getGroupClassDetailsUrl(this.courtEventId);
        return url;
    }

    onAddNote(): void {
        this.courtEventNoteSaveLauncherService.openCourtNoteSave({ courtEventId: this.courtEventId });
    }

    public isAnyNote(courtClass: GroupClassEventDetailsModel): boolean {
        return courtClass.notes?.length > 0;
    }
}
